export var OPT_IN_CHECKBOX_LABEL = 'I opt in to future communications from this vendor';
export var DEFAULT_PLACE_ORDER_BUTTON_TEXT = 'Place Order';